export enum ProductType {
  Unknown = 'Unknown',
  Cellphone = 'Cellphone',
  CellphoneAccessory = 'CellphoneAccessory',
  Smartwatch = 'Smartwatch',
  MbbRouter = 'MbbRouter',
  MbbEquipment = 'MbbEquipment',
  MbbSubscription = 'MbbSubscription',
  Subscription = 'Subscription',
  DeliveryOption = 'DeliveryOption',
  VoiceSubscription = 'VoiceSubscription',
  M2MSubscription = 'M2MSubscription',
}

export enum SearchDisplayType {
  Grid = 'grid',
  List = 'list',
}

export enum MobilePhoneAvailability {
  equipmentUpgrade = 'MobilBytte',
}
